import React from 'react';
const timeToPercent = (hours: number, minutes: number) => {
  const totalMinutes = 12 * 60; // 8:00 to 20:00
  const elapsedMinutes = (hours - 8) * 60 + minutes;
  return elapsedMinutes / totalMinutes * 100;
};
export function GanttTimeline() {
  const timeLabels = [8, 10, 12, 14, 16, 18, 20];
  return;
}